import AdminPatients from "./AdminPatients";
export default AdminPatients;